<template>
  <v-app :dark="darkMode">
    <v-toolbar app :clipped-left="clipped">
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab small v-model="darkMode" @click.native="darkMode = !darkMode">
        <v-icon>invert_colors</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      darkMode: false,
      clipped: false,
      drawer: false,
      fixed: false,
      items: [
        {
          icon: "home",
          title: "Parents",
          href: "/parents"
        }
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: "Beit Bialik"
    };
  },
  name: "App"
};
</script>
